var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyAverage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 64.6875C17.8969 64.6875 4.3125 51.1031 4.3125 34.5C4.3125 17.8969 17.8969 4.3125 34.5 4.3125C51.1031 4.3125 64.6875 17.8969 64.6875 34.5C64.6875 51.1031 51.1031 64.6875 34.5 64.6875Z",
    fill: "#B1D4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41H20V45H49V41Z",
    fill: "#0000C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7734 32.5469C29.8574 32.5469 31.5469 30.8574 31.5469 28.7734C31.5469 26.6894 29.8574 25 27.7734 25C25.6894 25 24 26.6894 24 28.7734C24 30.8574 25.6894 32.5469 27.7734 32.5469Z",
    fill: "#0000C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0044 32.5469C44.0884 32.5469 45.7778 30.8574 45.7778 28.7734C45.7778 26.6894 44.0884 25 42.0044 25C39.9204 25 38.231 26.6894 38.231 28.7734C38.231 30.8574 39.9204 32.5469 42.0044 32.5469Z",
    fill: "#0000C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyAverage);
export default __webpack_public_path__ + "static/media/icon-smiley-average.ef64995dd6b0aae37ef22726d721be99.svg";
export { ForwardRef as ReactComponent };